import { TableCell } from '@material-ui/core';
import React from 'react';
import { LinkComponent } from 'src/components';
import { AlternatingColorTableRow } from 'src/components/table';
import { Customer } from 'src/types';

interface Props {
  customer: Customer;
  onCustomerPress: (customer: Customer) => void;
}

export const CustomerListItem = ({ customer, onCustomerPress }: Props) => {
  return (
    <AlternatingColorTableRow
      onClick={() => onCustomerPress(customer)}
      hover
      key={customer.id}
    >
      <TableCell>
        <LinkComponent
          href={`/app/customers/${customer.id}`}
          title={`${customer?.first_name} ${customer?.last_name}`}
        />
      </TableCell>
      <TableCell>{customer.contact_no}</TableCell>
    </AlternatingColorTableRow>
  );
};
